//
//
//
//
//
//

export default {
  name: 'IndexSidebar',
  props: {
    utmClick: {
      type: String,
      default: 'register_index_r'
    }
  },
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexSidebar.vue